import { z } from 'zod'

const nonEmpty = z.string().trim().min(1)

const Base = z.object({ VITE_API_BASE_URL: nonEmpty })

export type ConsoleEnv = { apiBaseUrl: string }

const describeIssues = (error: z.ZodError): string => error.issues.map((issue) => issue.path.join('.')).join('、')

const parseOrThrow = <T extends z.ZodType>(schema: T, source: unknown): z.infer<T> => {
  const result = schema.safeParse(source)
  if (!result.success) throw new Error(`Console 設定不完整，缺少或不合法：${describeIssues(result.error)}`)
  return result.data
}

export const readConsoleEnv = (source: Record<string, string | undefined>): ConsoleEnv => {
  const base = parseOrThrow(Base, source)
  return { apiBaseUrl: base.VITE_API_BASE_URL }
}

export const CONSOLE_ENV: ConsoleEnv = readConsoleEnv(import.meta.env as unknown as Record<string, string | undefined>)
